import * as React from 'react';
import { FLEX_COLUMN, FLEX_ROW } from '../../layout/flexBox';
import { css } from '@emotion/core';
import { Str } from '../../localization/translationKeys';
import { FORM_COLUMN } from '../../forms/styles/form';
import { btnStyle } from '../../forms/styles/button';
import Msg from '../../localization/Msg';
import { COLORS } from '../../globalStyle/colors';
import { Link, useHistory } from 'react-router-dom';
import { useRef } from 'react';
import { useMount } from '../../core/hooks/useMount';


const styles = {
  header: [FLEX_ROW, css`margin-bottom: 16px;`],
  form:   [FLEX_COLUMN, FORM_COLUMN],
  btn:    [btnStyle.primary(COLORS.GREEN), css`display: block;`],
  link:   [css`color:${COLORS.WHITE};`],
};


type Props = {
  className?: string;
  loginUrl: string;
};

const ForgotPasswordSuccessForm: React.FC<Props> = props => {
  const history = useHistory();

  const handleKeyPress = React.useCallback((e) => {
    if(e.charCode===13){
      //window.location.href = props.loginUrl;
      history.push(props.loginUrl);
    }
   },
   [props.loginUrl, history],
  );

  const linkRef = useRef<HTMLAnchorElement>(null);

  useMount(() => linkRef.current?.focus() );

  return (
    <div css={FLEX_COLUMN} onKeyPress={(e) => handleKeyPress(e)}>
      <Msg css={styles.header} str={Str.TempPasswordSent} />
      <Link
        to={props.loginUrl}
        css={styles.btn}
        ref={linkRef}
      >
        <Msg str={Str.BackToLogin} css={styles.link} />
      </Link>
    </div>
  );
};


export default ForgotPasswordSuccessForm;
